export const JWT_KEY = 'X_NXBR_ACCESS_TOKEN'

/**
 * @function SaveToken
 * @description Armazena um JWT no localStorage.
 * @param {string} token O JWT para ser armazenado no localStorage.
 * @returns {void}
 */
const SaveToken = (token) => {
  window.localStorage.setItem(JWT_KEY, token)
}

/**
 * @function GetToken
 * @description Obtém o JWT armazenado no localStorage.
 * @returns {string} O JWT armazenado no localStorage.
 */
const GetToken = () => window.localStorage.getItem(JWT_KEY)

/**
 * @function GetTokenHeader
 * @description Obtém o header do JWT armazenado no localStorage.
 * @returns {Object} O header do JWT armazenado no localStorage.
 */
const GetTokenHeader = () => {
  const rawToken = GetToken()
  const rawHeader = rawToken.split('.')[0]
  const decodedRawHeader = atob(rawHeader)
  const decodedHeader = JSON.parse(decodedRawHeader)
  return decodedHeader
}

/**
 * @function GetTokenPayload
 * @description Obtém o payload do JWT armazenado no localStorage.
 * @returns {Object} O payload do JWT armazenado no localStorage.
 */
const GetTokenPayload = () => {
  const rawToken = GetToken()
  const rawPayload = rawToken.split('.')[1]
  const decodedRawPayload = atob(rawPayload)
  const decodedPayload = JSON.parse(decodedRawPayload)
  return decodedPayload
}

/*
 * @function GetRoles
 * @description Obtém as roles do payload do token JWT armazenado no localStorage.
 * @returns {array} Roles do payload do token JWT armazenado no localStorage.
*/
const GetRoles = () => {
  const payload = GetTokenPayload()
  const roles = payload.roles ? payload.roles.split(',') : []
  return roles
}

const GetUserName = () => {
  const payload = GetTokenPayload()
  const nome = payload.nome ? payload.nome : null
  return nome
}

const GetUserId = () => {
  const payload = GetTokenPayload()
  const id = payload.userId ? payload.userId : null
  return id
}

/**
 * @function DestroyToken
 * @description Destrói o JWT armazenado no localStorage.
 * @returns {void}
 */
const DestroyToken = () => window.localStorage.removeItem(JWT_KEY)

export const JWTService = {
  SaveToken,
  GetToken,
  GetTokenHeader,
  DestroyToken,
  GetTokenPayload,
  GetRoles,
  GetUserName,
  GetUserId
}

export default JWTService



// WEBPACK FOOTER //
// ./src/shared/services/jwt.js